import styled from 'styled-components';

import { PatientEntitlement } from '@dreryk/egabinet-patient-frontend-api';

import { ValueRendererProps } from '@dreryk/react-components';

import { PatientEntitlementTypeTooltip } from './PatientEntitlementTypeTooltip';

export const StyledPatientEntitlementTypeCell = styled.div`
   display: flex;
   gap: 4px;
   justify-content: space-between;
   align-items: center;
   width: 100%;
`;

StyledPatientEntitlementTypeCell.displayName = 'StyledPatientEntitlementTypeCell';

export const PatientEntitlementTypeCell = (props: ValueRendererProps<PatientEntitlement>): JSX.Element => {
   return (
      <StyledPatientEntitlementTypeCell>
         {props.bean.patientEntitlementTypeDisplayName}
         {props.bean.entitlementTypes ? (
            <PatientEntitlementTypeTooltip entitlementTypes={props.bean.entitlementTypes} />
         ) : null}
      </StyledPatientEntitlementTypeCell>
   );
};
